module.exports = __webpack_public_path__ + "static/media/car-speakers.e9a30130.jpg";